import { call, put } from 'redux-saga/effects';
import { retriable } from '../retriable';
import { ERROR_MESSAGE, SUCCESS_MESSAGE } from '../../redux/modules/message/message-actions';
import { HIDE_SPINNER, SHOW_SPINNER } from '../../redux/modules/spinner/spinner';
import {
    didApiCallFailDueToUnauthorizedUser,
    didApiCallFailDueToVersionMismatch,
    getErrorMessage,
    isValidFunction,
} from '../../constants/CommonUtil';
import { MISMATCH_IN_VERSION, SESSION_TIMEOUT } from '../../redux/modules/login/login-actions';
import messages from '../../constants/messages';
import { CREATE_ADD_STOCK_FAILURE, CREATE_ADD_STOCK_SUCCESS } from '../../redux/modules/addStock/addStock-actions';
import { ADD_STOCK_OPERATION } from '../../mapper/AddStockMapper';
import { FETCH_STOCK_MOVE_SUCCESS } from '../../redux/modules/stockMove/stockMove-actions';

export default function* createAddStockWorker(action) {
    try {
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const response = yield call(retriable().post, action.api, action.payload);
        yield put({
            type: CREATE_ADD_STOCK_SUCCESS,
            data: response.data,
        });
        // added to set stock move state
        yield put({
            type: FETCH_STOCK_MOVE_SUCCESS,
            data: response.data,
        });
        if (isValidFunction(action.successCallback)) {
            action.successCallback(response.data);
        }
        if (action.payload.status === ADD_STOCK_OPERATION.SAVE) {
            const msg = action.payload.uuid ? messages.ADD_STOCK.UPDATE.SUCCESS :
                messages.ADD_STOCK.CREATE.SUCCESS;
            yield put({ type: SUCCESS_MESSAGE, message: msg });
        } else {
            yield put({ type: SUCCESS_MESSAGE, message: messages.ADD_STOCK.CONFIRM.SUCCESS });
        }
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        // do error action
        if (isValidFunction(action.failureCallBack)) {
            action.failureCallBack();
        }
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            let msg = '';
            if (action.payload.operation === ADD_STOCK_OPERATION.SAVE) {
                msg = action.payload.uuid ? messages.ADD_STOCK.UPDATE.FAILED :
                    messages.ADD_STOCK.CREATE.FAILED;
            } else {
                msg = messages.ADD_STOCK.CONFIRM.FAILED;
            }
            yield put({ type: ERROR_MESSAGE, message: `${msg}: ${getErrorMessage(e)}` });
        }
        yield put({ type: CREATE_ADD_STOCK_FAILURE, data: action.payload });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}
